"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NumberFieldFormat = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactAria = require("react-aria");
var _numberfield = require("@react-stately/numberfield");
var _focus = require("@react-aria/focus");
var _Input = require("./Input.common");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _ForecastLocaleProvider = require("../../../../locale/ForecastLocaleProvider");
var _i18n = require("@react-aria/i18n");
var _input = require("./input.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var NumberFieldFormat = exports.NumberFieldFormat = /*#__PURE__*/function (NumberFieldFormat) {
  NumberFieldFormat["PERCENT"] = "percent";
  NumberFieldFormat["CURRENCY"] = "currency";
  return NumberFieldFormat;
}({});
function getFormatOptions(format, currencyCode, minimumFractionDigits, maximumFractionDigits) {
  var formatOptions = {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits
  };
  switch (format) {
    case NumberFieldFormat.PERCENT:
      return _objectSpread({}, formatOptions, {
        style: 'percent'
      });
    case NumberFieldFormat.CURRENCY:
      return _objectSpread({}, formatOptions, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol'
      });
    default:
      return formatOptions;
  }
}
var NumberField = function NumberField(_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _input.TextFieldSize.LARGE : _ref$size,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? _input.TextFieldWidth.FLEX : _ref$width,
    label = _ref.label,
    dataCy = _ref['data-cy'],
    dataUserpilot = _ref['data-userpilot'],
    format = _ref.format,
    currencyCode = _ref.currencyCode,
    minimumFractionDigits = _ref.minimumFractionDigits,
    maximumFractionDigits = _ref.maximumFractionDigits,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    errorText = _ref.errorText,
    helperText = _ref.helperText,
    onChange = _ref.onChange,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? _Input.InputFieldAlign.LEFT : _ref$align,
    onBlur = _ref.onBlur;
  var ref = _react.default.useRef(null);
  var _ref2 = (0, _i18n.useLocale)(),
    locale = _ref2.locale;
  var formatOptions = (0, _react.useMemo)(function () {
    return getFormatOptions(format, currencyCode, minimumFractionDigits, maximumFractionDigits);
  }, [format, currencyCode, minimumFractionDigits, maximumFractionDigits]);
  var state = (0, _numberfield.useNumberFieldState)({
    defaultValue: defaultValue,
    onChange: onChange,
    value: value,
    locale: locale,
    formatOptions: formatOptions,
    minValue: minValue,
    maxValue: maxValue,
    onBlur: onBlur
  });
  var _ref3 = (0, _reactAria.useNumberField)({
      label: label,
      isDisabled: disabled,
      errorMessage: errorText,
      description: helperText,
      onChange: onChange,
      defaultValue: defaultValue,
      formatOptions: formatOptions,
      minValue: minValue,
      maxValue: maxValue,
      onBlur: onBlur
    }, state, ref),
    labelProps = _ref3.labelProps,
    inputProps = _ref3.inputProps,
    descriptionProps = _ref3.descriptionProps,
    errorMessageProps = _ref3.errorMessageProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ForecastLocaleProvider.ForecastLocaleProvider, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoDisplayWrapper.InfoDisplayWrapper, {
      label: label,
      ariaLabelProps: labelProps,
      helperText: helperText,
      ariaHelpTextProps: descriptionProps,
      errorText: errorText,
      ariaErrorTextProps: errorMessageProps,
      "data-cy": dataCy,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
        isTextInput: true,
        focusRingClass: 'focus-ring',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, _objectSpread({}, inputProps, {
          hasError: !!errorText,
          width: width,
          height: size,
          ref: ref,
          "data-cy": dataCy,
          "data-userpilot": dataUserpilot,
          align: align
        }))
      })
    })
  });
};
NumberField.FORMAT = NumberFieldFormat;
NumberField.SIZE = _input.TextFieldSize;
NumberField.WIDTH = _input.TextFieldWidth;
NumberField.ALIGN = _Input.InputFieldAlign;
var _default = exports.default = NumberField;